import { render, staticRenderFns } from "./DistrictForm.vue?vue&type=template&id=070448a5&"
import script from "./DistrictForm.vue?vue&type=script&lang=js&"
export * from "./DistrictForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports